import { netCards } from '@/mocks/homeContent';

export default function NetBlacklist() {
  return (
    <section id="网红黑料" className="bg-background-50">
      <div className="mx-auto max-w-[1240px] px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex items-end justify-between gap-4">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
                <i className="ri-live-line flex h-5 w-5 items-center justify-center" />
              </span>
              <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">网红黑料</h2>
              <span className="rounded-full bg-secondary-200 px-2.5 py-1 text-xs font-bold text-secondary-900">直播现场</span>
            </div>
            <p className="mt-2 text-sm text-foreground-600">带货翻车、人设考古与机构开撕，红人圈的每场风波都归档在此</p>
          </div>
          <span className="hidden items-center gap-1.5 whitespace-nowrap rounded-md bg-background-100 px-3 py-2 text-xs text-foreground-500 ring-1 ring-background-200 md:flex">
            <i className="ri-loop-left-line flex h-4 w-4 items-center justify-center" />今日已更 6 篇
          </span>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {netCards.map((c, i) => (
            <a key={i} href="#专题话题" className="group flex flex-col overflow-hidden rounded-xl bg-background-100 ring-1 ring-background-200 transition hover:-translate-y-1 hover:ring-primary-300">
              <div className="relative h-44 w-full overflow-hidden sm:h-40">
                <img src={c.img} alt={c.title} title={`网红黑料 ${c.title}`} className="h-full w-full object-cover object-center transition duration-500 group-hover:scale-105" />
                <span className="absolute right-2.5 top-2.5 rounded-sm bg-background-50/90 px-1.5 py-0.5 font-label text-xs text-primary-700">
                  热 {c.heat}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-3.5 md:p-4">
                <h3 className="line-clamp-2 font-heading text-base font-bold leading-6 text-foreground-950 transition group-hover:text-primary-700">
                  {c.title}
                </h3>
                <div className="mt-3 flex flex-wrap items-center gap-1.5">
                  {c.tags.map((t) => (
                    <span key={t} className="whitespace-nowrap rounded-sm bg-secondary-100 px-2 py-0.5 text-[11px] font-bold text-secondary-800">
                      #{t}
                    </span>
                  ))}
                </div>
                <div className="mt-auto flex items-center justify-between border-t border-background-200 pt-3" style={{ marginTop: 'auto' }}>
                  <span className="text-[11px] text-foreground-500">网红黑料 · 专题讨论</span>
                  <span className="inline-flex items-center gap-1 whitespace-nowrap text-xs font-bold text-primary-600 transition group-hover:gap-2">
                    进帖聊 <i className="ri-arrow-right-line flex h-4 w-4 items-center justify-center" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}